"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var PartnerTrackersList_1 = require("./tracker/PartnerTrackersList");
var PartnerTrackerEditor_1 = require("./tracker/PartnerTrackerEditor");
var PartnerOffersList_1 = require("./offer/PartnerOffersList");
var PartnerOfferEditor_1 = require("./offer/PartnerOfferEditor");
var PartnerMessagesList_1 = require("./messages/PartnerMessagesList");
var PartnerPayDetailsList_1 = require("./paydetail/PartnerPayDetailsList");
var PartnerPayDetailEditor_1 = require("./paydetail/PartnerPayDetailEditor");
var PartnerBalancesList_1 = require("./balances/PartnerBalancesList");
var PartnerAuthLogList_1 = require("./auth_logs/PartnerAuthLogList");
var ParrtnerPromoCodesTemplatesList_1 = require("./promo_codes_templates/ParrtnerPromoCodesTemplatesList");
var PartnerPromoCodeTemplateEditor_1 = require("./promo_codes_templates/PartnerPromoCodeTemplateEditor");
var PartnerConfig = /** @class */ (function (_super) {
    __extends(PartnerConfig, _super);
    function PartnerConfig(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_opt_tracker = "opt.tracker";
        _this.tab_opt_offer = "opt.offer";
        _this.tab_opt_message = "opt.message";
        _this.tab_opt_paydetails = "opt.paydetails";
        _this.tab_opt_balances = "opt.balances";
        _this.tab_opt_auth = "opt.auth";
        _this.tab_opt_promo_templates = "opt.promo.templates";
        return _this;
    }
    PartnerConfig.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            APPPartnerTrackerMode: "LIST",
            AppPartnerTrackerRecord: null,
            APPPartnerOfferMode: "LIST",
            AppPartnerOfferRecord: null,
            messages_mode: "LIST",
            unread_messages: false,
            messages_page_num: 0,
            page_size: this.props.state.UITablePageSize,
            APPPartnerPayDetailsMode: "LIST",
            AppPartnerPayDetailsRecord: null,
            APPPartnerPromoCodeTemplateMode: "LIST",
            AppPartnerPromoCodeTemplateRecord: null,
            authlog_page_num: 0
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.props.state.setExtBreadCrumbPath(["Настройки партнера"]);
    };
    PartnerConfig.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PartnerConfig.prototype.backToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    PartnerConfig.prototype.newTrackerClick = function () {
        this.setState({ APPPartnerTrackerMode: "NEW", AppPartnerTrackerRecord: null });
    };
    PartnerConfig.prototype.editTrackerClick = function (record) {
        this.setState({ APPPartnerTrackerMode: "EDIT", AppPartnerTrackerRecord: record });
    };
    PartnerConfig.prototype.backToTrackersListClick = function () {
        this.setState({ APPPartnerTrackerMode: "LIST", AppPartnerTrackerRecord: null });
    };
    PartnerConfig.prototype.getTrackerObject = function () {
        if (this.state.APPPartnerTrackerMode === "LIST") {
            return (React.createElement(PartnerTrackersList_1.default, { state: this.props.state, data: this.props.listPartnerTrackers, onGoBackClick: this.backToRootClick.bind(this), onNewClick: this.newTrackerClick.bind(this), onEditClick: this.editTrackerClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPPartnerTrackerMode === "NEW") {
            return (React.createElement(PartnerTrackerEditor_1.default, { data: this.props.listPartnerTrackers, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToTrackersListClick.bind(this) }));
        }
        if (this.state.APPPartnerTrackerMode === "EDIT") {
            return (React.createElement(PartnerTrackerEditor_1.default, { data: this.props.listPartnerTrackers, record: this.state.AppPartnerTrackerRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToTrackersListClick.bind(this) }));
        }
        return null;
    };
    PartnerConfig.prototype.newOfferClick = function () {
        this.setState({ APPPartnerOfferMode: "NEW", AppPartnerOfferRecord: null });
    };
    PartnerConfig.prototype.editOfferClick = function (record) {
        this.setState({ APPPartnerOfferMode: "EDIT", AppPartnerOfferRecord: record });
    };
    PartnerConfig.prototype.backToOffersListClick = function () {
        this.setState({ APPPartnerOfferMode: "LIST", AppPartnerOfferRecord: null });
    };
    PartnerConfig.prototype.getOfferObject = function () {
        if (this.state.APPPartnerOfferMode === "LIST") {
            return (React.createElement(PartnerOffersList_1.default, { state: this.props.state, data: this.props.listPartnerOffers, onGoBackClick: this.backToRootClick.bind(this), onNewClick: this.newOfferClick.bind(this), onEditClick: this.editOfferClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPPartnerOfferMode === "NEW") {
            return (React.createElement(PartnerOfferEditor_1.default, { data: this.props.listPartnerOffers, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToOffersListClick.bind(this), availOffersList: this.props.listAvailOffers }));
        }
        if (this.state.APPPartnerOfferMode === "EDIT") {
            return (React.createElement(PartnerOfferEditor_1.default, { data: this.props.listPartnerOffers, record: this.state.AppPartnerOfferRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToOffersListClick.bind(this), availOffersList: this.props.listAvailOffers }));
        }
        return null;
    };
    PartnerConfig.prototype.onPageMessagesConfigChanged = function (pageNum, pageSize) {
        var _this = this;
        this.setState({
            messages_page_num: pageNum
        }, function () {
            _this.props.state.setTablePageSize(pageSize, true);
        });
    };
    PartnerConfig.prototype.setShowOnlyUnreadMessagesClick = function (checked) {
        this.setState({ unread_messages: checked });
    };
    PartnerConfig.prototype.onGoBackClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    //        <Tabs.TabPane tab={<span style={{ width: 200, minWidth: 200 }}><FA left icon="envelope" />Сообщения</span>} key={this.tab_player_messages}>
    PartnerConfig.prototype.getMessagesObject = function () {
        return (React.createElement(PartnerMessagesList_1.default, { state: this.props.state, dataMessages: this.props.PartnersMessagesList, dlgMessage: this.props.dlgMessage, onPageConfigChanged: this.onPageMessagesConfigChanged.bind(this), pageNum: this.state.messages_page_num, pageSize: this.state.page_size, partner: this.props.record, onGoBackClick: this.onGoBackClick.bind(this), onShowOnlyUnreadMessagesClick: this.setShowOnlyUnreadMessagesClick.bind(this), isShowOnlyUnreadMessages: this.state.unread_messages }));
    };
    PartnerConfig.prototype.newPayDetailClick = function () {
        this.setState({ APPPartnerPayDetailsMode: "NEW", AppPartnerPayDetailsRecord: null });
    };
    PartnerConfig.prototype.editPayDetailClick = function (record) {
        this.setState({ APPPartnerPayDetailsMode: "EDIT", AppPartnerPayDetailsRecord: record });
    };
    PartnerConfig.prototype.backToPayDetailsListClick = function () {
        this.setState({ APPPartnerPayDetailsMode: "LIST", AppPartnerPayDetailsRecord: null });
    };
    PartnerConfig.prototype.getPayDetailObject = function () {
        if (this.state.APPPartnerPayDetailsMode === "LIST") {
            return (React.createElement(PartnerPayDetailsList_1.default, { state: this.props.state, data: this.props.PartnersPayDetailsList, onGoBackClick: this.backToRootClick.bind(this), onNewClick: this.newPayDetailClick.bind(this), onEditClick: this.editPayDetailClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPPartnerPayDetailsMode === "NEW") {
            return (React.createElement(PartnerPayDetailEditor_1.default, { data: this.props.PartnersPayDetailsList, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToPayDetailsListClick.bind(this), ListAffilatesPayoutsAvail: this.props.ListAffilatesPayoutsAvail }));
        }
        if (this.state.APPPartnerPayDetailsMode === "EDIT") {
            return (React.createElement(PartnerPayDetailEditor_1.default, { data: this.props.PartnersPayDetailsList, record: this.state.AppPartnerPayDetailsRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToPayDetailsListClick.bind(this), ListAffilatesPayoutsAvail: this.props.ListAffilatesPayoutsAvail }));
        }
        return null;
    };
    PartnerConfig.prototype.getBalancesObject = function () {
        return (React.createElement(PartnerBalancesList_1.default, { state: this.props.state, data: this.props.PartnersBalancesList, onGoBackClick: this.backToRootClick.bind(this), rootRecord: this.props.record }));
    };
    PartnerConfig.prototype.onPageAuthLogConfigChanged = function (pageNum, pageSize) {
        var _this = this;
        this.setState({
            authlog_page_num: pageNum
        }, function () {
            _this.props.state.setTablePageSize(pageSize, true);
        });
    };
    PartnerConfig.prototype.getAuthLogsObject = function () {
        return (React.createElement(PartnerAuthLogList_1.default, { state: this.props.state, dataLogs: this.props.PartnersAuthLogsList, onPageConfigChanged: this.onPageAuthLogConfigChanged.bind(this), pageNum: this.state.authlog_page_num, pageSize: this.state.page_size, rootRecord: this.props.record, onGoBackClick: this.onGoBackClick.bind(this) }));
    };
    PartnerConfig.prototype.newPromoTemplateObjectClick = function () {
        this.setState({ APPPartnerPromoCodeTemplateMode: "NEW", AppPartnerPromoCodeTemplateRecord: null });
    };
    PartnerConfig.prototype.editPromoTemplateObjectClick = function (record) {
        this.setState({ APPPartnerPromoCodeTemplateMode: "EDIT", AppPartnerPromoCodeTemplateRecord: record });
    };
    PartnerConfig.prototype.backToPromoTemplatesListClick = function () {
        this.setState({ APPPartnerPromoCodeTemplateMode: "LIST", AppPartnerPromoCodeTemplateRecord: null });
    };
    PartnerConfig.prototype.getPromoTemplateObject = function () {
        if (this.state.APPPartnerPromoCodeTemplateMode === "LIST") {
            return (React.createElement(ParrtnerPromoCodesTemplatesList_1.default, { state: this.props.state, data: this.props.ListPartnersPromoCodeTemplates, onGoBackClick: this.backToRootClick.bind(this), onCreateClick: this.newPromoTemplateObjectClick.bind(this), onEditClick: this.editPromoTemplateObjectClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPPartnerPromoCodeTemplateMode === "NEW") {
            return (React.createElement(PartnerPromoCodeTemplateEditor_1.default, { data: this.props.ListPartnersPromoCodeTemplates, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToPromoTemplatesListClick.bind(this), brandsList: this.props.ListPartnersBrandsAvail, promoForBrandsList: this.props.ListPromoCodeTemplatesForBrandsAvail }));
        }
        if (this.state.APPPartnerPromoCodeTemplateMode === "EDIT") {
            return (React.createElement(PartnerPromoCodeTemplateEditor_1.default, { data: this.props.ListPartnersPromoCodeTemplates, record: this.state.AppPartnerPromoCodeTemplateRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToPromoTemplatesListClick.bind(this), brandsList: this.props.ListPartnersBrandsAvail, promoForBrandsList: this.props.ListPromoCodeTemplatesForBrandsAvail }));
        }
        throw "No available render for promo template objects active edit mode -> " + this.state.APPPartnerPromoCodeTemplateMode;
    };
    PartnerConfig.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_opt_offer },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "map-marker" }),
                        "\u0422\u0440\u0435\u043A\u0435\u0440\u044B"), key: this.tab_opt_message }, this.getTrackerObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "percent" }),
                        "\u041E\u0444\u0444\u0435\u0440\u044B"), key: this.tab_opt_offer }, this.getOfferObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "enveloper" }),
                        "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"), key: this.tab_opt_tracker }, this.getMessagesObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "user-secret" }),
                        "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438"), key: this.tab_opt_auth }, this.getAuthLogsObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "credit-card" }),
                        "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0435 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B"), key: this.tab_opt_paydetails }, this.getPayDetailObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "wallet" }),
                        "\u0411\u0430\u043B\u0430\u043D\u0441\u044B"), key: this.tab_opt_balances }, this.getBalancesObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "gift" }),
                        "\u0428\u0430\u0431\u043B\u043E\u043D\u044B \u043F\u0440\u043E\u043C\u043E"), key: this.tab_opt_promo_templates }, this.getPromoTemplateObject()))));
    };
    return PartnerConfig;
}(React.Component));
exports.default = PartnerConfig;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ui/component/PartnerConfig.tsx
// module id = 2433
// module chunks = 0